<!-- 留学攻略 -->
<template>
  <div class="page flex-col">
    <div class="navbar">
      <my-navbar class="navbarone"></my-navbar>
    </div>
    <div class="block_red flex-col">
    </div>
    <div class="block_9 flex-row">
      <div class="main">
        <!-- <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="../assets/newImage/椭圆 2.png"
          /> -->
        <img
          class="thumbnail_1"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb59cce0e73798de2431f26b74202ba9b19d58adc145d502515db964d7c84cd77"
        />
        <span class="text_13 buts" @click="back()">返回首页</span>
        <img
          class="thumbnail_2"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9cd2a54b44174a86dfcf7cf860a411307073c6418cfbb72587ca1e4acb495fb8"
        />
        <span class="text_14 buts" @click="abroad()">留学资讯 </span>
        <img
          v-if="tb_uuid"
          class="thumbnail_2"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9cd2a54b44174a86dfcf7cf860a411307073c6418cfbb72587ca1e4acb495fb8"
        />
        <span class="text_14 buts" @click="details()" v-if="tb_uuid">咨询详情</span>
      </div>
    </div>
    <!-- 留学攻略 -->
    <div class="main">
      <div v-show="road">
        <div class="block_10 flex-row">
          <div class="box_2 flex-col">
            <img
                class="image_3"
                referrerpolicy="no-referrer"
                :src="'api' + gaunyuList.tb_map_img"
              />
            <!-- <div class="text-wrapper_7 flex-col">
              <span class="text_15">日本留学新生全攻略</span>
              <span class="text_16">专注于日本国家留学服务</span>
            </div> -->
          </div>
          <!-- <div class="box_3 flex-col">
            <div class="text-wrapper_8 flex-row justify-between">
              <span class="text_17">热门攻略</span>
              <span class="text_18 buts" @click="goDingyue()">查看全部</span>
            </div>
            <div
              class="group_2 flex-wrap justify-content buts"
              v-for="(item, index) in liuxueList"
              :key="index"
              @click="strategy(item.tb_uuid)"
            >
              <img
                class="image_3"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngebc5f3e3a56a515b1bf08caf7cb31e42eaf33450c7559a5409c477b0e0a93026"
              />
              <div class="text-group_1 flex-col justify-between">
                <span class="text_21">{{ item.tb_title || "暂无数据"}}</span>
                <span class="text_22" v-html="item.tb_content"></span>
              </div>
            </div>
          </div> -->

          <div class="block_5 flex-col">
            <div class="box_3 flex-row justify-between">
              <div class="group_12 flex-col"></div>
              <span class="text_21">热门标签</span>
              <div class="group_13 flex-col"></div>
            </div>
            <span class="text_22">人気タグ</span>
            <div class="grid_1 flex-row">
              <div
                class="text-wrapper_07 flex-col buts"
                v-for="(item, index) in rm_tegList"
                :key="index"
                @click="address"
              >
                <span class="text_23">{{ item.tb_hxts_name }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="group_93 flex-row">
            <div class="image-text_2 flex-row justify-between">
              <img
                class="label_1"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng76069c20a500f507b2703c104fa254fb0ad6b8ac9405926612838b55c0090a34"
              />
              <span class="text-group_3" ref="dingyue_box_ref">重点推荐</span>
            </div>
          </div> -->
         <!-- <div
              class="block_2 flex-row buts"
              @click="getzxxq(detailist.tb_uuid)"
            >
              <div class="group_8 flex-col">
                <img
                    style="
                    height: 100%;
                    /* overflow: hidden;
                    white-space: normal;
                    text-overflow: ellipsis; */
                  "
                :src="'api' + detailist.tb_home_img"
                    />
              </div>
              <div class="group_9 flex-col">
                <div
                  style="
                    height: 82%;
                    overflow: hidden;
                    white-space: normal;
                    text-overflow: ellipsis;
                  "
                >
                  <span class="text_105">{{ detailist.tb_title }}</span>
                  <span
                    class="paragraph_01"
                    v-html="detailist.tb_content"
                  ></span>
                </div>
                <div class="box_01 flex-row justify-between">
                  <div class="image-text_01 flex-row justify-between">
                    <img
                      class="thumbnail_03"
                      referrerpolicy="no-referrer"
                      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng04453c040779e5492216dc4c60b70da1966c90d620fcea88be9ab2604832e5a5"
                    />
                    <span class="text-group_01"
                      >发布时间：{{
                        detailist.tb_add_time == null
                          ? "1"
                          : detailist.tb_add_time.split("T")[0]
                      }}&nbsp;{{
                        detailist.tb_add_time == null
                          ? "1"
                          : detailist.tb_add_time.split("T")[1]
                      }}</span
                    >
                  </div>
                  <div class="image-text_02 flex-row justify-between">
                    <span class="text-group_02 buts">查看</span>
                    <img
                      class="thumbnail_04"
                      referrerpolicy="no-referrer"
                      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng97c249608266b644f91e15e013521a8db107e30a67a78ac90c7689ac7d563fc7"
                    />
                  </div>
                </div>
              </div>
            </div> -->

        <div class="block_11 flex-row">
          <div class="group_3 flex-row">
            <div class="image-text_2 flex-row justify-between">
              <img
                class="label_1"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng76069c20a500f507b2703c104fa254fb0ad6b8ac9405926612838b55c0090a34"
              />
              <span class="text-group_3" ref="dingyue_box_ref">推荐列表</span>
            </div>
          </div>
          <div class="group_4 flex-col"></div>
          <span class="text_25">留学情報一覧</span>
        </div>
        <div class="block_gl flex-wrap  buts">
          <div class="block_12">
            <div
              class="text_wrapper_9"
              :class="{ text_wrapper_gl: tb_type_title === ''}"
              @click="xuexiao()"
            >
              全部推荐
            </div>
          </div>
          <div class="block_12" v-for="(item, index ) in titleList"  :key="index">
            <div
              class="text_wrapper_9"
              :class="{ text_wrapper_gl: tb_type_title == item.tb_type_title }"
              @click="xuexiao(item)"
            >
              {{ item.tb_type_title }}
            </div>
          </div>
        </div>
        <!-- <div class="block_13">
          <div class="block_14 flex-wrap justify-between">
            <div class="image-text_3" v-for="(item, index) in liebiaoList"
                :key="index">
              <div class="block_15 flex-col"><img :src="'api' + item.tb_home_img"
                style="width: 285px; height: 180px"></div>
              <span class="text-group_4"
                >{{item.tb_title}}</span
              >
            </div>
          </div>
        </div> -->
        <div class="block_13 flex-row">
          <div class="block_14 flex-wrap justify-content">
            <div
              class="image-text_3 flex-col justify-between buts"
              v-for="(item, index) in liebiaoList"
              :key="index"
              @click="strategy(item.tb_uuid)"
            >
              <div class="block_15 flex-col">
                <img
                  :src="'api' + item.tb_home_img"
                  style="width: 285px; height: 180px"
                />
              </div>
              <span class="text-group_4">{{ item.tb_title || "暂无数据"}}</span>
            </div>
          </div>
        </div>
        <div class="block_194 flex-col"></div>
        <div class="block_18 flex-row">
          <!-- <span class="text_30">上一页</span>
          <div class="text-wrapper_12 flex-col">
            <span class="text_31">1</span>
          </div>
          <span class="text_32">2</span> <span class="text_33">3</span>
          <span class="text_34">4</span> <span class="text_35">5</span>
          <span class="text_36">下一页</span> -->
          <el-pagination
            background
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            layout="prev, pager, next"
            limit = "8"
            :current-page.sync="page"
            :page-size = "8"
            :total="count1"
            :prev-text="'上一页'"
            :next-text="'下一页'"
          >
          </el-pagination>
        </div>
                  <!-- 咨询列表 -->
    <div class="block_93 flex-row justify-between">
              <div class="group_910 flex-row">
                <div class="image-text_93 flex-row justify-between">
                  <img
                    class="label_91"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng85bcf62f52cf9c8b167cc0766a820ecdb11a0a67e685b7720d8f4401550a3564"
                  />
                  <span class="text-group_93">留学资讯</span>
                </div>
                <div class="group_911 flex-col"></div>
              </div>
              <span class="text_916">留学情報</span>
            </div>
            <div
              v-for="(item, index) in zixunList"
              :key="index"
              class="image-text_94 flex-row justify-between buts"
              @click="getzxxq(item.tb_uuid)"
            >
              <div class="box_92 flex-row">
                <div class="text-group_94 flex-col justify-between">
                  <span class="text_917">{{
                    item.tb_add_time.split("-")[2].split("T")[0]
                  }}</span>
                  <span class="text_918">{{
                    item.tb_add_time.split("-")[0] +
                      "-" +
                      item.tb_add_time.split("-")[1]
                  }}</span>
                </div>
                <!-- <div class="text-group_5 flex-col justify-between">
                  <span class="text_17">07</span>
                  <span class="text_18">2023-07</span>
                </div> -->
              </div>
              <div class="text-group_96 flex-col justify-between">
                <span class="text_919">{{ item.tb_title }}</span>
                <!-- <span class="text_20">{{item.tb_content}}</span> -->
                <span class="text_920" v-html="item.tb_content"></span>
              </div>
            </div>

            <div class="block_94 flex-col"></div>
            <div class="section_910 flex-row">
              <!-- <span class="text_53">上一页</span>
              <div class="text-wrapper_20 flex-col">
                <span class="text_54">1</span>
              </div>
              <span class="text_55">2</span> <span class="text_56">3</span>
              <span class="text_57">4</span> <span class="text_58">5</span>
              <span class="text_59">下一页</span> -->
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                limit="8"
                :page-size = 8
                :total="count2"
                :prev-text="'上一页'"
                :next-text="'下一页'"
              >
              </el-pagination>
            </div>
    </div>
  </div>



    <!-- <div class="group_54 flex-col">
      <my-footer class="navbarone"></my-footer>
    </div> -->

    <!-- 攻略详情 -->
    <div v-show="tail">
      <div class="main2">
        <div class="tailgroup_5 flex-row justify-between">
          <div class="tailbox_7 flex-col">
            <span class="tailtext_16">{{ detailsList.tb_title }}</span>
            <div class="tailgroup_6 flex-row">
              <img
                class="tailthumbnail_4"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngbe63dcce60301e7bfe878336e5060d8a0dda0aa2615db93e3f6b0575d5f4a7d8"
              />
              <span class="tailtext_17">浏览次数：{{ browse }}</span>
              <img
                class="tailthumbnail_5"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng04453c040779e5492216dc4c60b70da1966c90d620fcea88be9ab2604832e5a5"
              />
              <span class="tailtext_18">
                发布时间：{{ (detailsList.tb_add_time|| "").replace("T", " ") }}
                 </span>
            </div>
            <div class="tailgroup_7 flex-col"></div>
            <span class="tailtext_19"></span>
            <div class="tailimage-text_1 flex-col justify-between">
              <span
                class="tailtext-group_1"
                v-html="detailsList.tb_content"
              ></span>
            </div>
          </div>
          <!-- <div class="tailbox_8 flex-col">
            <div class="tailgroup_8 flex-row justify-between">
              <div class="tailblock_1 flex-col"></div>
              <span class="tailtext_20">热门标签</span>
              <div class="tailblock_2 flex-col"></div>
            </div>
            <span class="tailtext_21">人気タグです</span>
            <div class="tailgrid_1 flex-row">
              <div class="tailtext-wrapper_10 flex-col"  v-for="(item, index) in rm_tegList"
                :key="index"
                @click="address">
                <span class="tailtext_25">{{ item.tb_hxts_name }}</span>
              </div>
            </div>
          </div> -->
        </div>
        <!-- <div class="tailgroup_9 flex-row justify-between"> -->
          <!-- <div class="tailbox_9 flex-col">
            <div class="tailsection_1 flex-row">
              <div class="tailimage-text_2 flex-row justify-between">
                <img
                  class="taillabel_1"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng76069c20a500f507b2703c104fa254fb0ad6b8ac9405926612838b55c0090a34"
                />
                <span class="tailtext-group_2">攻略列表</span>
              </div>
            </div>
            <span class="tailtext_35">留学情報一覧</span>
            <div class="tailsection_2 flex-col"></div>
            <div class="tailsection_glqb flex-wrap justify-between">
              <div
                class="tailimage-text_3 flex-col justify-between"
                v-for="(item, index) in quanbuList"
                :key="index"
                @click="strategy(item.tb_uuid)"
              >
                <div class="tailgroup_10 flex-col"></div>
                <span class="tailtext-group_32">{{ item.tb_title || "暂无数据"}}</span>
            </div>
          </div>
        </div> -->
       <!-- </div> -->
      </div>
    </div>



    <!-- <el-dialog
            title=""
            :visible.sync="dialogVisible"
            width="100%"
            :before-close="handleClose"
           >
      <video :src="videoSrc" controls="controls" autoplay>
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog> -->
    <my_article></my_article>
    <div class="group_54 flex-col">
      <my-footer class="navbarone"></my-footer>
    </div>
  </div>
</template>

<script>
import navbar from "../components/navbar/navbar.vue";
import footer from "../components/footer/footer.vue";
import article from "../components/article/article.vue";
import { GetWenzhang, GetWenzhangdefault } from "../api/wenzhang";
import { GetWenzhangone,wenzhangtitle, numberOfViews } from "../api/wenzhangone";
import { GetRmteg } from "../api/rm-teg";
import { GetGuanyu } from "../api/guanyu";
export default {
  components: {
    "my-navbar": navbar,
    "my-footer": footer,
    my_article: article,
  },
  data() {
    return {
      road: true,
      tail: false,
      loopData0: [],
      tb_tuiguang: "", // 不维护，表示查询全部 1表示没上热门，0表示热门
      tb_type_title: '', //攻略列表
      tb_sign: "", //1表示查询咨询文章列表   2 表示查询攻略文章列表
      limit: "8", //一页显示条数
      page: 1, //当前页
      browse: "", //浏览人数
      rm_tegList: [], //获取热门标签
      count: 0,
      count1: 0,
      count2: 0,//分页总数
      liuxueList: [], //留学热门
      liebiaoList: [], //留学列表
      zixunList: [], //资讯列表
      detailsList: [], //攻略详情数据
      quanbuList: [], //全部攻略列表
      titleList: [],
      // index_gl: "",
      chang: 0,
      tb_uuid: "",
      detailsdist: {},
      detailist:{},
      // tb_sign: "1", //1表示查询咨询文章列表   2 表示查询攻略文章列表
      up_page_date: {},
      next_page_date: {},
      gaunyuList: {},
    };
  },
  created() {
    if(this.$route.query.id){
      // this.tb_uuid = this.$route.query.id
      this.details()
      this.getglxqList()
    }
    this.getList();
    this.getliebiaoList();
    this.getzixunList();
    this.getList1();
    // this.getglxqList();
    this.getquanbuList();
    this.Wenzhangtitle();
    this.getrmtegasd();
    this.getguanyu();
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
    if (this.$route.query.tb_uuid != null) {
      // this.tb_uuid = this.$route.query.tb_uuid;
      this.tail = true;
      this.road = false;
      this.getzxxq(this.tb_uuid);
    } else {
      this.tb_uuid = "";
    }
  },
  mounted() {
    if (this.$route.query.studyid) {
      this.tb_uuid = this.$route.query.studyid
      this.strategy(this.$route.query.studyid);
    }
  },
  methods: {
    handleSizeChange1(val) {
            console.log(`每页 ${val} 条`);
        },
    handleCurrentChange1(val) {
      console.log(`当前页: ${val}`, this.formInline);
      let tb_sign = "2";
      let limit = this.limit;
      let page = val;
      let tb_type_title = this.tb_type_title;
      let tb_tuiguang = "1";
      GetWenzhang({ tb_tuiguang, limit, page, tb_type_title,tb_sign  }).then((response) => {
        this.liebiaoList = response.data.date;
        this.count1 = response.data.count;
      });
    },

    handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        let tb_sign = "2";
        let limit = this.limit;
        let page = val;
        let tb_tuiguang = "0";
        let tb_type_title = this.tb_type_title;
        GetWenzhang({ tb_tuiguang, tb_sign, limit, page, tb_type_title }).then((response) => {
        this.zixunList = response.data.date;
        this.count2 = response.data.count;
      });

    },
    bofang(item) {
      this.dialogVisible = true;
      this.videoSrc = item;
    },
    handleClose(done) {
      done();
    },
    //返回首页
    back() {
      this.$router.push("page/index");
    },
    //留学攻略
    abroad() {
      this.road = true;
      this.tail = false;
      this.tb_uuid = "";
      this.$router.push({
        name: "study",
        query: {
          // studyid: id
        }
      });
    },
    //攻略详情
    details() {
      this.road = false;
      this.tail = true;
    },
    //留学攻略热门接口
    getList() {
      let tb_sign = "2";
      let tb_tuiguang = "0";
      let limit = this.limit;
      let page = this.page;
      // let tb_type_title=this.tb_type_title;
      GetWenzhang({ tb_sign, tb_tuiguang, limit, page }).then((response) => {
        this.liuxueList = response.data.date;
      });
    },
    //留学攻略列表
    getliebiaoList() {
      let tb_sign = "2";
      let limit = this.limit;
      let tb_type_title = this.tb_type_title;
      let tb_tuiguang = "1";
      let page = this.page;

      GetWenzhang({page ,tb_sign, tb_tuiguang, limit, tb_type_title  }).then((response) => {
        this.liebiaoList = response.data.date;
        this.count1 = response.data.count;
      console.log(`每页条`, response.data.count,page);
      });
    },
    //留学咨询列表
    getzixunList() {
      let tb_sign = "2";
      let limit = this.limit;
      let tb_tuiguang = "0";
      let tb_type_title = this.tb_type_title;
      GetWenzhang({ tb_tuiguang, tb_sign, limit, tb_type_title }).then((response) => {
        this.zixunList = response.data.date;
        this.count2 = response.data.count;
      });
    },
    getList1() {
      GetWenzhangdefault().then(response => {
        this.detailist = response.data.date
      });
      GetRmteg().then(response => {
        this.rm_tegList = response.data;
      });
    },


    //留学攻略全部列表
    getquanbuList() {
      let tb_sign = this.tb_sign;
      let limit = this.limit;
      let page = this.page;
      let tb_type_title = "";
      let tb_tuiguang = "";
      GetWenzhang({ tb_sign, limit, page, tb_type_title, tb_tuiguang }).then(
        (response) => {
          this.quanbuList = response.data.date;
          // this.count = response.data.count;
        }
      );
    },
    //攻略详情数据
    getglxqList() {
      // let tb_uuid = this.tb_uuid;
      GetWenzhangone({ tb_uuid }).then((response) => {
        numberOfViews({tb_wenzhang_uuid: tb_uuid}).then(res => {
            console.log(res)
          })
        this.detailsList = response.data.date;
        this.browse = response.data.info_number;
      });
    },
    //攻略详情
    strategy(id) {
      // document.documentElement.scrollTop = 0
      // this.details();
      // let tb_uuid = id;
      // this.tb_uuid = id;
      GetWenzhangone({ tb_uuid: this.tb_uuid }).then((response) => {
        numberOfViews({tb_wenzhang_uuid: this.tb_uuid}).then(res => {
            console.log(res)
          })
        this.road = false;
        this.tail = true;
        this.detailsList = response.data.date;
        this.browse = response.data.info_number;
      });
      let url = window.location.origin + "/study"
      window.open(url + `?studyid=${id}`);
      this.$router.push({
        name: "study",
        query: {
          studyid: id
        }
      });
    },
        // 获取资讯详情
     getzxxq(uuid) {
      // document.documentElement.scrollTop = 0;
      // this.tb_uuid = uuid;
      GetWenzhangone({ tb_uuid: this.tb_uuid }).then( response => {
        if (response.code == 20000) {
          numberOfViews({tb_wenzhang_uuid: uuid}).then(res => {
            console.log(res)
          })
          this.road = false;
          this.tail = true;
          this.detailsList = response.data.date;
          this.browse = response.data.info_number;
          this.up_page_date = response.data.up_page_data;
          this.next_page_date = response.data.next_page_data;
        }
      });
      let url = window.location.origin + "/study"
      window.open(url + `?studyid=${uuid}`);
    },
    //攻略列表切换
    xuexiao(val) {
      if(val === undefined){
        this.tb_type_title = ''
        this.page = 1;
      }
      if(val){
        this.tb_type_title = val.tb_type_title;
        this.page = 1;
      }
      this.getliebiaoList();
    },
    //查看跳到攻略列表
    goDingyue() {
      // 获取元素在页面中的位置

      // document
      //   .getElementById("agentTitle")
      //   .scrollIntoView({ block: "start", behavior: "smooth" });
      // 跳转到指定位置并且平滑滚动
      this.$el
        .querySelector(".text-group_3")
        .scrollIntoView({ block: "start", behavior: "smooth" });
    },
    async Wenzhangtitle(){
      const res = await wenzhangtitle({tb_sign:'2'})
      this.titleList = res.data
    },
    address() {
      this.$router.push({
        name: "schoolCommon",
        query: {
          teg_key: "特色",
        },
      });
    },
    getrmtegasd(){
      GetRmteg().then((response) => {
        this.rm_tegList = response.data;
      });
    },
    getguanyu() {
      GetGuanyu().then(response => {
        this.gaunyuList = response.data;
      });
    }
  }
};
</script>
<style src="../../static/css/study.css" scoped />

.article {
  display: flex;
  justify-content: center;
}
.link {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/study.vue